import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { ExpirationDateRequest } from '../models/insurance-business-types/expiration-date-request';
import { CheckOverlappingInsuranceRequest, InsuranceListOptionRequest, InsuranceInfoForSalesOrderViewModel } from '../models/insurances';
import { PatientInsuranceOption } from '../models/patients';

@Injectable({
  providedIn: 'root'
})
export class InsuranceDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getPatientInsurancesEligibleAsync(patientId: number, insuranceId?: number, cancellationToken?: Promise<any>): Promise<PatientInsuranceOption[]> {
    return this.httpClient.getJsonAsync<PatientInsuranceOption[]>('insurances/GetInsuranceEligibleOptions', { patientId: patientId, insuranceId }, cancellationToken);
  }

  public getPatientInsurancesAsync(searchString: string, patientId: number, clinicId?: number, insuranceId?: number, cancellationToken?: Promise<any>): Promise<PatientInsuranceOption[]> {
    const request: InsuranceListOptionRequest = { searchString: searchString, patientId: patientId, clinicId, insuranceId };
    return this.httpClient.getJsonAsync<PatientInsuranceOption[]>('insurances/options', request, cancellationToken);
  }

  public getInsuranceInfoForSalesOrderAsync(id: number, cancellationToken?: Promise<any>): Promise<InsuranceInfoForSalesOrderViewModel> {
    return this.httpClient.getJsonAsync<InsuranceInfoForSalesOrderViewModel>('insurances/GetInsuranceInfoForSalesOrder', {id: id}, cancellationToken);
  }

  public checkOverlappingInsuranceExists(request: CheckOverlappingInsuranceRequest, timeout?: Promise<any>): Promise<boolean> {
    return this.httpClient.getJsonAsync<boolean>('insurances/checkOverlappingInsuranceExists', request, timeout, false);
  }

  public getExpirationDateExtendAllowed(request:ExpirationDateRequest,timeout?:Promise<boolean>):Promise<boolean>{
    return this.httpClient.getJsonAsync<boolean>('insurances/getExpirationDateExtendAllowed', request, timeout, false);
  }
}
